import React from 'react'

// Original vectors from Figma frame 217, node 302:773.
const CavityRiskIcon = ({ size = 48 }) => (
  <svg
    width={size}
    height={size}
    viewBox="122 491 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M131.755 500.949C132.144 498.851 133.185 496.928 134.73 495.456C136.298 493.964 138.581 493.502 140.605 494.268L143.42 495.333C145.082 495.962 146.918 495.962 148.58 495.333L151.395 494.268C153.419 493.502 155.702 493.964 157.27 495.456C158.815 496.928 159.856 498.851 160.245 500.949L161.19 506.052C161.695 508.782 160.79 511.582 158.782 513.499C157.531 514.692 156.824 516.346 156.824 518.075V521.77C156.824 525.901 153.474 529.25 149.343 529.25H148.957L149.578 521.611C149.751 519.484 148.071 517.662 145.937 517.662C143.802 517.662 142.123 519.484 142.295 521.611L142.916 529.25H142.657C138.526 529.25 135.176 525.901 135.176 521.77V518.075C135.176 516.346 134.469 514.692 133.218 513.499C131.21 511.582 130.305 508.782 130.81 506.052L131.755 500.949Z"
      fill="#8FB4FF"
    />
    <path
      d="M139.674 502.865L140.689 492.717C144.337 493.575 148.153 493.399 151.707 492.208L152.326 492L147.792 500.835L153.881 502.865L143.733 510.983L144.748 504.894L139.674 502.865Z"
      fill="white"
    />
  </svg>
)

export default CavityRiskIcon
